<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--left" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="m16 20-8-7.5L16 5" stroke="currentColor"/></svg>
</template>